import "./datatable.scss";
import {DataGrid, enUS, GridToolbar} from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import newRequest from "../../context/newRequest";

const DatatableUsers = ({columns}) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];
    const [query, setQuery] = useState("");


    const [pageState, setPageState] = useState({
        isLoading: false,
        data: [],
        total: 0,
        page: 1,
        pageSize: 10,
    })

    useEffect(() => {
        const fetchData = async () => {
            console.log('ON')
            setPageState(old => ({ ...old, isLoading: true }))
            const response = await newRequest.get(`${path}?id=${query}&page=${pageState.page}`)
            const json = await response
            console.log(json);
            setPageState(old => ({ ...old, isLoading: false, data: json.data.data, total: json.data.paging.total_item }))
        }
        fetchData()
    }, [pageState.page, pageState.pageSize,query ])


    const handleDelete = async (id, token) => {
        try {
            await axios.delete(`/${path}/${id}` , {
                headers: {
                    'Authorization': `$Bearer ${token}`
                }
            }
        );
            const list = pageState.data
            setPageState(old => ({ ...old, isLoading: false, data:list.filter((item) => item.id !== id)  }));
        } catch (err) {}
    };

    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/${path}/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>
                        <Link to={`/${path}/update/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update Users
                            </div>
                        </Link>
                    </div>
                );
            },
        },
    ];
    return (
        <div className="datatable">
            <div className="datatableTitle">
                {path.toUpperCase()}
                <div className="search">
                    <input type="text"
                           placeholder="userId"
                           onChange={(e) => setQuery(e.target.value.toLowerCase())}
                    />
                    <SearchOutlinedIcon/>
                </div>
                <div>

                <Link to={`/${path}/new`} className="link">
                    Add New
                </Link>
                </div>
            </div>
            <DataGrid
                className="datagrid"
                localeText={enUS.components.MuiDataGrid.defaultProps.localeText}
                components={{
                    Toolbar: GridToolbar
                }}
                columns={columns.concat(actionColumn)}
                autoHeight
                rows={pageState.data}
                rowCount={pageState.total}
                loading={pageState.isLoading}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                page={pageState.page - 1}
                pageSize={pageState.pageSize}
                paginationMode="server"
                onPageChange={(newPage) => {
                    setPageState(old => ({ ...old, page: newPage + 1 }))
                }}
                onPageSizeChange={(newPageSize) => setPageState(old => ({ ...old, pageSize: newPageSize }))}

            />
        </div>
    );
};

export default DatatableUsers;